/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Adicionar"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remover tudo"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var ptBR = Object.assign(TranslationProviderComponent, {
  translations
});

export { ptBR as p };
//# sourceMappingURL=pt-BR-Bx9S7HFh.js.map
